var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingFacilityWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1967_6392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4.75C5.5 4.33579 5.16421 4 4.75 4C4.33579 4 4 4.33579 4 4.75V19.25C4 19.6642 4.33579 20 4.75 20C5.16421 20 5.5 19.6642 5.5 19.25V4.75ZM17.5 4.75C17.5 4.33579 17.1642 4 16.75 4C16.3358 4 16 4.33579 16 4.75V9.25C16 9.66421 16.3358 10 16.75 10C17.1642 10 17.5 9.66421 17.5 9.25V4.75ZM10.75 4C11.1642 4 11.5 4.33579 11.5 4.75V7.25C11.5 7.66421 11.1642 8 10.75 8C10.3358 8 10 7.66421 10 7.25V4.75C10 4.33579 10.3358 4 10.75 4ZM11.5 10.75C11.5 10.3358 11.1642 10 10.75 10C10.3358 10 10 10.3358 10 10.75V13.25C10 13.6642 10.3358 14 10.75 14C11.1642 14 11.5 13.6642 11.5 13.25V10.75ZM10.75 16C11.1642 16 11.5 16.3358 11.5 16.75V19.25C11.5 19.6642 11.1642 20 10.75 20C10.3358 20 10 19.6642 10 19.25V16.75C10 16.3358 10.3358 16 10.75 16ZM20.0262 13.4623C20.3191 13.7552 20.3191 14.2301 20.0262 14.523L18.055 16.4943L20.0262 18.4656C20.3191 18.7585 20.3191 19.2333 20.0262 19.5262C19.7333 19.8191 19.2585 19.8191 18.9656 19.5262L16.9943 17.555L15.023 19.5262C14.7301 19.8191 14.2552 19.8191 13.9623 19.5262C13.6695 19.2333 13.6695 18.7585 13.9623 18.4656L15.9336 16.4943L13.9623 14.523C13.6695 14.2301 13.6695 13.7552 13.9623 13.4623C14.2552 13.1695 14.7301 13.1695 15.023 13.4623L16.9943 15.4336L18.9656 13.4623C19.2585 13.1695 19.7333 13.1695 20.0262 13.4623Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1967_6392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingFacilityWhite);
export default __webpack_public_path__ + "static/media/missing-facility-white.9ed908ad91b6c5525ff42ae5ec075141.svg";
export { ForwardRef as ReactComponent };